import { useTheme } from '@mui/material/styles';
import { HelpOutlineOutlined } from '@mui/icons-material';
import { formatToAmount } from '@qrios/frontend-library';

import locales from '../../../../../../../constants/locales';
import DetailsList from '../../../../../../common/details-list';
import DetailsFactory from '../../../../../../common/details-list/detailsFactory';

import { Operation } from './interfaces';

interface Props {
  operation: Operation;
}

const UnknownOperation = ({ operation }: Props) => {
  const theme = useTheme();
  const { details } = operation;

  const error = details.failureCause ? { errorMessage: details.failureCause } : undefined;

  return (
    <DetailsFactory
      header={{
        icon: { component: HelpOutlineOutlined, color: theme.palette.grey['700'] },
        id: operation.id,
        date: operation.date,
        status: operation.status
      }}
      error={error}
      operationContent={
        <DetailsList
          items={[
            {
              label: locales.operation.label.creditAccountNumber,
              value: details.creditAccount.accountNumber
            },
            { label: locales.operation.label.creditBank, value: details.creditAccount.bankName },
            {
              label: locales.operation.label.purpose,
              value: details.purpose
            },
            {
              label: locales.operation.label.amount,
              value: formatToAmount(operation.amount.value)
            },
            {
              label: locales.operation.label.externalTransactionId,
              value: details.externalTransactionId
            },
            {
              label: locales.operation.label.cost,
              value: formatToAmount(operation.cost.value)
            }
          ]}
        />
      }
    />
  );
};

export default UnknownOperation;
